import { useCompany, useGetUserRoleOptions } from '@dispatch/shared/hooks';
import {
  CapacityDashboard_Request,
  MultiSelectOption,
  TaskPeril,
} from '@dispatch/shared/types';
import { isEmpty, isNull } from 'lodash';
import React from 'react';

export const useFriendlyNameMapper = (
  filters?: CapacityDashboard_Request | null,
  perils?: TaskPeril[]
) => {
  const { roles: companyRoles } = useCompany();
  const roles = useGetUserRoleOptions(companyRoles || []);

  const rolesLookup = React.useMemo(() => {
    if (roles.companyUserRoles === undefined) return;
    if (roles.companyUserRoles === null) return;
    if (roles.companyUserRoles.length === 0) return;

    return roles.companyUserRoles.reduce(
      (acc: { [key: string]: string }, role: MultiSelectOption) => {
        acc[role.value] = role.title;
        return acc;
      },
      {}
    );
  }, [roles.companyUserRoles]);

  const perilsLookup = React.useMemo(() => {
    if (isNull(perils) || isEmpty(perils)) return {};

    return perils?.reduce(
      (acc: { [key: string]: string }, peril: TaskPeril) => {
        acc[peril.code] = peril.description;
        return acc;
      },
      {}
    );
  }, [perils]);

  return {
    ...filters,
    perils: filters?.perils.map((peril) => perilsLookup?.[`${peril}` || '']),
    roles: filters?.roles?.map((role) => rolesLookup?.[`${role}` || '']),
  };
};
